// 好友模块翻译 - 简体中文
export default {
  friends: {
    title: '好友',
    subtitle: '管理你的好友关系',
    addFriend: '添加好友',
    noFriends: '还没有好友',
    addFriendsHint: '添加好友一起记账吧！',
    unknownUser: '未知用户',
    removeFriend: '删除好友',
    confirmRemove: '确认删除好友？',
    removeSuccess: '好友删除成功',
    removedFriend: '已删除好友 {name}',
    
    // 标签
    tagsUpdated: '朋友标签已更新',
    allFriends: '全部',
    noTaggedFriends: '暂无"{tag}"标签的朋友',
    tryOtherTags: '尝试选择其他标签或添加新朋友',
    
    // 加载状态
    loading: {
      title: '连接好友中...',
      subtitle: '正在为你加载好友信息',
    },
    // 标签编辑器
    editTags: '编辑朋友标签',
    selectedTags: '已选标签',
    presetTags: '预设标签',
    myTags: '我的标签',
    addCustomTag: '添加自定义标签',
    tagInputPlaceholder: '输入标签名称（如：健身伙伴）',
    tagHelp: '标签帮助',
    tagAlreadyExists: '该标签已存在',
    tagSaveSuccess: '朋友标签更新成功',
    tagSaveError: '保存失败',
    saving: '保存中...',
    save: '保存',
    noTagsSelected: '未选择标签',
    success: '成功',
    error: '错误',
    tagHelpText: `• 标签可以帮助你分类管理朋友
• 创建聚餐时可以通过标签快速选择邀请对象
• 一个朋友可以拥有多个标签
• 建议使用简短明确的标签名称`,
    
    // 预设标签翻译
    presetTagCoworker: '同事',
    presetTagClassmate: '同学', 
    presetTagNeighbor: '邻居',
    presetTagRoommate: '室友',
    presetTagFamily: '家人',
    presetTagGymBuddy: '健身伙伴',
    presetTagGameBuddy: '游戏伙伴',
    presetTagLunchBuddy: '午餐伙伴',
    presetTagTravelBuddy: '旅行伙伴',
    presetTagStudyBuddy: '学习伙伴',
    presetTagWorkPartner: '工作伙伴',
    
    // 搜索和添加
    contactLabel: '联系方式',
    contactPlaceholder: '输入邮箱、用户名或手机号',
    searchPlaceholder: '搜索用户名、邮箱或手机号',
    searchEmpty: '没有找到用户',
    searchError: '搜索失败，请稍后重试',
    searchHint: '输入完整信息以获得更准确的搜索结果',
    searching: '搜索中...',
    searchResults: '搜索结果',
    addByContact: '通过联系方式添加',
    scanQRCode: '扫描二维码添加',
    shareMyQR: '分享我的二维码',
    sendRequest: '发送好友请求',
    
    // 好友请求消息
    messageLabel: '好友请求消息（可选）',
    messagePlaceholder: '介绍一下自己，让对方更容易接受你的好友请求',
    
    // 消息提示
    loadFailed: '加载好友列表失败',
    searchFailed: '搜索失败',
    incompleteUserInfo: '用户信息不完整',
    enterContactInfo: '请输入邮箱、用户名或手机号',
    requestSent: '好友请求发送成功！',
    requestFailed: '发送好友请求失败',
    removeFailed: '删除好友失败',
  }
};
